import { useIntl } from 'react-intl';

import { Modal, ModalProps } from '../../../../../design-system/components/modal/Modal';
import { UseModalState } from '../../../../../design-system/components/modal/useModal';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { PaymentLogo } from '../../../../../shared/components/PaymentLogo/PaymentLogo';

import style from './ReassuranceBannerPaymentModal.module.css';

type Props = UseModalState & {
    onClose: ModalProps['onClose'];
};

export function ReassuranceBannerPaymentModal({ onClose, ...props }: Props) {
    const { formatMessage } = useIntl();

    const title = formatMessage({
        id: 'page.home.reassuranceBanner.paymentModal.title',
    });

    return (
        <Modal {...props} title={title} size="small" onClose={onClose}>
            <div className={style.content}>
                <div className={style.block}>
                    <Typography as="div" scale="primary-body-bold">
                        ✨{' '}
                        {formatMessage({
                            id: 'page.home.reassuranceBanner.paymentModal.content.firstTitle',
                        })}
                    </Typography>
                    <Typography as="div" scale="primary-body-regular">
                        {formatMessage({
                            id: 'page.home.reassuranceBanner.paymentModal.content.firstText',
                        })}
                    </Typography>
                </div>
                <div className={style.block}>
                    <Typography as="div" scale="primary-body-bold">
                        📅{' '}
                        {formatMessage({
                            id: 'page.home.reassuranceBanner.paymentModal.content.secondTitle',
                        })}
                    </Typography>
                    <Typography as="div" scale="primary-body-regular">
                        {formatMessage({
                            id: 'page.home.reassuranceBanner.paymentModal.content.secondText',
                        })}
                    </Typography>
                </div>
                <div className={style.block}>
                    <Typography as="div" scale="primary-body-bold">
                        💳{' '}
                        {formatMessage({
                            id: 'page.home.reassuranceBanner.paymentModal.content.thirdTitle',
                        })}
                    </Typography>
                    <Typography as="div" scale="primary-body-regular">
                        {formatMessage({
                            id: 'page.home.reassuranceBanner.paymentModal.content.thirdText',
                        })}
                    </Typography>
                    <PaymentLogo />
                </div>
            </div>
        </Modal>
    );
}
